import { tab as Devices } from '../../main/devices/route.config.js';
import { tab as Home } from '../../main/home/route.config.js';
import { tab as Mine } from '../../main/mine/route.config.js';
import { tab as Records } from '../../main/records/route.config.js';
import { tab as ReportsHejia } from '../../main/reports/route.config.js';

export const tabItems = [Home, Records, ReportsHejia, Devices, Mine];
